import type { LeaseRepresentation } from '@/common/types/interaction';
import { GQLInteractionType } from '@/generated/graph-api';
import {
  buildDualCoverSheetConfig,
  buildLandlordCoverSheetConfig,
  buildTenantCoverSheetConfig,
} from './lease';
import { buildListingCoverSheetConfig } from './listing/buildListingCoverSheetConfig';
import { buildOfferCoverSheetConfig } from './offer/buildOfferCoverSheetConfig';
import type { CoverSheetConfig } from './types';

/**
 * Gets the appropriate coversheet configuration based on interaction type and state
 */
export function getLocalCoverSheetConfig(
  state: string,
  interactionType: GQLInteractionType,
  representationType?: LeaseRepresentation | null,
): CoverSheetConfig {
  if (interactionType === GQLInteractionType.listing) {
    return buildListingCoverSheetConfig(state);
  }

  if (interactionType === GQLInteractionType.offer) {
    return buildOfferCoverSheetConfig(state);
  }

  if (interactionType === GQLInteractionType.lease) {
    if (representationType === 'landlord') {
      return buildLandlordCoverSheetConfig(state);
    }
    if (representationType === 'tenant') {
      return buildTenantCoverSheetConfig(state);
    }
    return buildDualCoverSheetConfig(state);
  }

  throw new Error(`Unsupported interaction type: ${interactionType}`);
}
